export const MENU_ENDPOINTS = {
    BASE: '/Administracion/MenuUsuario',
} as const;
